import { FC, ReactNode, useState, useEffect } from "react";
import "./style.scss";

interface SidePanelProps {
  active: boolean;
  children: ReactNode;
  className?: string;
  title?: string;
  direction?: "left" | "right";
}

export const SidePanel: FC<SidePanelProps> = ({
  active,
  children,
  className = "",
  title = "",
  direction = "left",
}) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (active) {
      const timer = setTimeout(() => {
        setShouldShow(true);
      }, 200);
      return () => clearTimeout(timer);
    } else {
      setShouldShow(false);
    }
  }, [active]);

  if (!shouldShow) return null;

  return (
    <div className={`side-panel ${className} ${direction}`}>
      <div className="side-panel-content">
        <div className="side-panel-title">{title}</div>
        {children}
      </div>
    </div>
  );
};
